import { Typography } from '@festina-life/ui/structure'
import { useEffect, useMemo } from 'react'

import { useHook } from '../../lenteHooks'
import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'

function CompanyNavigationItemInternal({
  tenantId,
  companyId,
  onRenderFinished,
}: {
  tenantId: string
  companyId: string
  onRenderFinished?: (textContent: string) => void
}) {
  const { shouldShowName, shouldShowInternalId, shouldShowExternalId } =
    useHook('general.search.useRecentSearchDisplaySettings')()

  const { data: externalId } = useHook('fetchers.crm.useFetchExternalId')(
    {
      tenantId,
      internalId: companyId,
    },
    { enabled: shouldShowExternalId },
  )
  const { data: companyData } = useHook(
    'fetchers.crm.useFetchCompanyVersionLatest',
  )(
    {
      tenantId,
      companyId,
    },
    { enabled: shouldShowName },
  )

  const textContent = useMemo(() => {
    const name = shouldShowName ? companyData?.name : ''

    let idFormatted = shouldShowExternalId ? externalId : ''

    if (shouldShowInternalId) {
      // For consistency, internal ID is always paranthesized if external ID should be visible.
      idFormatted += shouldShowExternalId ? ` (${companyId})` : companyId
    }

    return [name, idFormatted].filter(Boolean)
  }, [
    companyData?.name,
    companyId,
    externalId,
    shouldShowExternalId,
    shouldShowInternalId,
    shouldShowName,
  ])

  useEffect(
    () => onRenderFinished?.(textContent.join(', ')),
    [onRenderFinished, textContent],
  )

  return (
    <>
      {textContent.map((text, index) => (
        <Typography key={text} intensity={index === 0 ? 'primary' : 'tertiary'}>
          {text}
        </Typography>
      ))}
    </>
  )
}

export const CompanyNavigationItem = withLifeErrorBoundary(
  CompanyNavigationItemInternal,
)
